import { MutableRecordStore } from '@deqo/foundation';
import { PreferencesData } from '../../api/endpoints/me';
import { HandwritingFontList } from '../../platform/assets/InAppFontList';
import { Colors } from './../../ui';

export type HandwritingMode = 'individual' | 'uniform' | 'off';
export type HandwritingModeOption = { key: HandwritingMode, label: string };
export const HandwritingModeOption = {
    all: [
        { key: 'individual', label: 'Individual' } as HandwritingModeOption,
        { key: 'uniform', label: 'Uniform' } as HandwritingModeOption,
        { key: 'off', label: 'Off' } as HandwritingModeOption,
    ],
    for: (value: HandwritingMode) => HandwritingModeOption.all.find(x => x.key === value),
};

export type MouseMode = 'auto' | 'mouse' | 'trackpad';
export type MouseModeOption = { key: MouseMode, label: string };
export const MouseModeOption = {
    all: [
        { key: 'auto', label: 'Auto' } as MouseModeOption,
        { key: 'mouse', label: 'Mouse' } as MouseModeOption,
        { key: 'trackpad', label: 'Trackpad' } as MouseModeOption,
    ],
    for: (value: MouseMode) => MouseModeOption.all.find(x => x.key === value),
};

const preferencesTemplate = {
    announcement: '',
    color: Colors.blue500,
    handwriting: HandwritingFontList[0].label,
    handwritingMode: 'individual' as HandwritingMode,
    mouseMode: 'auto' as MouseMode,
    slapping: true,
    scrooge2024: true,
    editorModePopup: true,
    gfxLevel: 2,
    haug: true,
    legacyBoards: true,
    hideOthers: false,
    notificationUnreads: true,
    notificationAssignment: true,
    notificationDaily: true,
    notificationWeekly: true,
    notificationEmailMention: true,
};

export class PreferencesModel extends MutableRecordStore(preferencesTemplate) {

    public static async load(provider: () => Promise<PreferencesData>) {
        const initial = await provider();
        const model = new PreferencesModel();
        model.setState(initial);
        return [
            model,
            async () => {
                const latest = await provider();
                model.updateState(latest);
            }
        ] as const;
    }
}
